'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.historyForThread = undefined;

var _reselect = require('reselect');

var _getEntry = require('conversations-async-data/indexed-async-data/operators/getEntry');

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _getThreadHistories = require('./getThreadHistories');

var _getStubbedThreadHistory = require('../../stubbed-thread-history/selectors/getStubbedThreadHistory');

var _threadFromProps = require('../../threads/selectors/threadFromProps');

var historyForThread = exports.historyForThread = (0, _reselect.createSelector)([_getThreadHistories.getThreadHistories, _getStubbedThreadHistory.getStubbedThreadHistory, _threadFromProps.threadFromProps], function (histories, stubbedThreadHistory, thread) {
  var threadId = (0, _threadGetters.getThreadId)(thread);
  if (typeof threadId !== 'number') {
    return null;
  }

  return (0, _getEntry.getEntry)(threadId, histories);
});